import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Variant } from '../components/Featured/components/Card/Card';

import {
  TXTCLI_El_Juego_Del_DXa,
  TXTWCL_Another_chance_to_spin_the_whe_ELL,
  TXTWCL_BONUS_ROUNDS,
  TXTWCL_ItXs_free_to_play_everydayX,
  TXTWCL_Looks_like_youXve_either_alrea_ELL,
  TXTWCL_POWERPATH_DAILY_TICKET,
  TXTWCL_Rake_X0X01_on_any_Poker_game_t_ELL,
  TXTWCL_Spin_of_the_Day,
  TXTWCL_Win_awesome_prizesX_like_Free__ELL,
  TXTWCL_YouXve_either_already_spun_the_ELL
} from './useCardDetails.messages.json';

interface CardDetails {
  title: React.ReactNode;
  infoTag: ResolverTag;
  hasImage?: boolean;
  description: React.ReactNode;
}

const getCardVariants = (
  isUK: boolean,
  isES: boolean,
  isDisabled: boolean
): Record<Variant, CardDetails> => ({
  StandardSotd: {
    title: isES ? (
      <Translation {...TXTCLI_El_Juego_Del_DXa} />
    ) : (
      <Translation {...TXTWCL_Spin_of_the_Day} />
    ),
    infoTag: ResolverTag.PRMCasinoPromoTerms,
    hasImage: true,
    description: isDisabled ? (
      isUK ? (
        <Translation {...TXTWCL_Looks_like_youXve_either_alrea_ELL} />
      ) : (
        <Translation {...TXTWCL_YouXve_either_already_spun_the_ELL} />
      )
    ) : (
      <>
        <Translation {...TXTWCL_ItXs_free_to_play_everydayX} />{' '}
        <Translation {...TXTWCL_Win_awesome_prizesX_like_Free__ELL} />
      </>
    )
  },
  BonusRounds: {
    title: <Translation {...TXTWCL_BONUS_ROUNDS} />,
    infoTag: ResolverTag.PRMCasinoPromoTerms,
    hasImage: true,
    description: <Translation {...TXTWCL_Another_chance_to_spin_the_whe_ELL} />
  },
  PowerPath: {
    title: <Translation {...TXTWCL_POWERPATH_DAILY_TICKET} />,
    infoTag: ResolverTag.PRMPowerPath,
    hasImage: false,
    description: <Translation {...TXTWCL_Rake_X0X01_on_any_Poker_game_t_ELL} />
  }
});

const useCardDetails = (isDisabled: boolean, variant: Variant): CardDetails => {
  const license = useSelector(select.account.getLicense);
  const isUK = license === LicenceId.UK;
  const isES = license === LicenceId.SPAIN;
  return useMemo(
    () => getCardVariants(isUK, isES, isDisabled)[variant],
    [isDisabled, isES, isUK, variant]
  );
};

export default useCardDetails;
